<template>
  <v-hover v-slot="data">
    <v-card
      class="text-center"
      color="transparent"
      flat
      v-on="$listeners"
    >
      <v-avatar
        size="60"
        style="border: var(--v-brand-green-dark-base) solid 1px;"
      >
        <v-img
          v-if="item.Category.Image"
          :class="hover && data.hover ? 'hover-zoom hover-zoom-active' : 'hover-zoom'"
          :src="item.Category.Image"
        />
      </v-avatar>

      <v-container
        :class="{'px-2 py-1': dense}"
        fluid
      >
        <v-row class="align-center">
          <v-col
            class="px-2"
            cols="12"
          >
            <v-card-title
              v-if="item.Category.Name"
              :class="{'pb-0': !item.Desc || dense, 'subtitle-2': dense}"
              class="px-0 pt-0 text-center"
            >
              <div
                class="overflow-hidden text-no-wrap fill-width"
                style="text-overflow: ellipsis;"
              >
                {{ item.Category.Name }}
              </div>
            </v-card-title>

            <v-card-subtitle
              v-if="item.Desc && !dense"
              class="px-0 pb-0 text-center"
            >
              <div
                class="overflow-hidden text-no-wrap fill-width"
                style="text-overflow: ellipsis;"
              >
                {{ item.Desc }}
              </div>
            </v-card-subtitle>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
import BrandCardMixin from '@/theme/default/views/home/BrandCard.js'

export default {
  name  : 'BrandCard',
  mixins: [BrandCardMixin]
}
</script>

<style scoped src="@/theme/default/views/home/BrandCard.css"></style>
<style scoped>
</style>
